"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
/**
 * REGEX check example:
 *
 * @example
 * // returns ['https://www.facebook.com', 'facebook.com']
 * domainRegex.exec('https://www.facebook.com')
 *
 *
 */
var domainRegExpression = /^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www\.)?([^:/\n]+)(?:(:\d*)?)/;
function trafficSource(criteria, services) {
    var referrerDomain = services.browserEnvironment.referrerDomain;
    var checkedCriteria = criteria[0];
    var criteriaDomains = checkedCriteria.values.map(function (value) {
        var parsedCheckingDomain = domainRegExpression.exec(value);
        return parsedCheckingDomain === null ? '' : parsedCheckingDomain[1];
    });
    return (0, helpers_1.parseStringCondition)(checkedCriteria.condition, referrerDomain, criteriaDomains);
}
exports.default = trafficSource;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhZmZpY1NvdXJjZS5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJzcmMvbGliL3NlcnZpY2VzL3RhcmdldHMvdHJhZmZpY1NvdXJjZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLHFDQUE4QztBQUc5Qzs7Ozs7Ozs7R0FRRztBQUVILElBQU0sbUJBQW1CLEdBQUcsZ0VBQWdFLENBQUE7QUFFNUYsU0FBd0IsYUFBYSxDQUFFLFFBQWtDLEVBQUUsUUFBc0I7SUFDN0YsSUFBTSxjQUFjLEdBQUcsUUFBUSxDQUFDLGtCQUFrQixDQUFDLGNBQWMsQ0FBQTtJQUVqRSxJQUFNLGVBQWUsR0FBRyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUE7SUFDbkMsSUFBTSxlQUFlLEdBQUcsZUFBZSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsVUFBQyxLQUFzQjtRQUN0RSxJQUFNLG9CQUFvQixHQUFHLG1CQUFtQixDQUFDLElBQUksQ0FBQyxLQUFlLENBQUMsQ0FBQTtRQUN0RSxPQUFPLG9CQUFvQixLQUFLLElBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxvQkFBb0IsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUN2RSxDQUFDLENBQUMsQ0FBQTtJQUVGLE9BQU8sSUFBQSw4QkFBb0IsRUFBQyxlQUFlLENBQUMsU0FBbUIsRUFBRSxjQUFjLEVBQUUsZUFBZSxDQUFDLENBQUE7QUFDckcsQ0FBQztBQVZELGdDQVVDIn0=